import React, { useEffect, useState } from "react";
import { logEvent } from "firebase/analytics";
import analytics from "../../../context/analytics";

//svgs
import {
  CartDetailedIcon,
  ChevronRightArrow,
  Curve,
  CurveOverImage,
  Phone,
  Time as TimeIcon,
  VoiceIcon,
} from "../../../components/svgs";
import {
  Button,
  CurveHolder,
  Span,
  StyledText,
  MainHolder,
  Children,
  Body,
  NotesContainer,
  CircleContainer,
  Dot,
  FooterImageContainer,
  FooterImage,
  FooterContainer,
  TipsContainer,
  TipContainer,
  Divider,
  DynamicButton,
} from "../../../components/common/basic";
import CountdownTimer from "../pulsenchill/components/CountdownTimer";
import { AlertModal, BackButton, FeatureHeader, FullScreenSelect } from "../../../components/common";
import GenericModal from "../../../components/common/genericModal";
import { useLoyalty, useTheme } from "../../../hooks";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import useMashupNWinPickup from "../mashupnwin/hooks/useMashupnWinPickup";
import RewardItemCard from "../mashupnwin/components/RewardItemCard";
import styled from "styled-components";
import MashupRedemptionStatus from "../mashupnwin/components/MashupRedemptionStatus";
import useTriviaPickup from "../trivia/hooks/useTriviaPickup";
import loyaltyService from '../../../services/loyalty'


const BlackFridayPickup = () => {
  const [showAlert, setShowAlert] = useState(false);
  const {
    region,
    regionFmt,
    setRegion,
    officeLocation,
    setOfficeLocation,
    officeLocations,
  } = useMashupNWinPickup();
  const { voucherData } = useTriviaPickup();

  const history = useHistory();
  const { loyaltyItem, setLoyaltyItem } = useLoyalty();

  const { pickUpRegion, pickupLocation, hasRedeemed } = loyaltyItem || {};
  if (pickupLocation) {
    history.push('/black-friday/order-details')
  }
  useEffect(() => {
    analytics().then((anl) =>
      logEvent(anl, "screen_view", {
        firebase_screen: "BlackFridayHome",
        firebase_screen_class: "BlackFridayHome",
      })
    );
  }, []);

  const { themeContext, theme } = useTheme();
  let themeColor = "background";
  let background = theme.colors[themeContext.activeTheme][themeColor];
  const token = JSON.parse(localStorage.getItem("token"));

  const handleSubmit = () => {
    loyaltyService.updateBlackFridayPickupLocation(token, {
      pickUpRegion: region,
      pickupLocation: officeLocation,
    })
      .then(() => {
        setLoyaltyItem({ ...loyaltyItem, pickUpRegion: region, pickupLocation: officeLocation })
        setShowAlert(true);
      })
      .catch(e => console.log(e))
  }

  return (
    <>
      <MainHolder>
        <Children>
          <BackButton onClick={() => history.goBack()} />

          <Header>
            <div style={{ textAlign: 'center' }}>
              <StyledText size={24} style={{ fontFamily: 'MTNMedium' }} margin="0">{'Black Friday'}</StyledText>
            </div>
          </Header>
          <Body>
            {
              // TODO: Update success property
              showAlert &&
              <AlertModal
                background={background}
                success={true}
                onClick={() => { setShowAlert(false) }} >
                <MashupRedemptionStatus
                  background={background}
                  history={history}
                  message="Pickup location submitted!"
                  url="/black-friday/order-details"
                />
              </AlertModal>
            }
            <div style={{ boxSizing: 'border-box', padding: '0 15px' }}>
              <RewardItemCard
                color={background}
                image={voucherData?.kfc?.imageUrl}
                points={"GHS 50"}
                name={"KFC Voucher"}
              />
              <hr style={{ margin: '15px 0', borderTop: 'none', borderBottom: '1px solid #ddd' }} />

              <div style={{ marginBottom: '150px' }}>
                <StyledText size={18} style={{ fontFamily: 'MTNRegular' }}>Pickup from MTN Office </StyledText>
                <FullScreenSelect
                  placeholder="Region"
                  data={regionFmt}
                  selected={region}
                  setValue={setRegion}
                  activeColor={background} />
                <FullScreenSelect
                  placeholder="MTN Office"
                  data={officeLocations}
                  selected={officeLocation}
                  setValue={setOfficeLocation}
                  activeColor={background} />
              </div>

              <div style={{ position: 'absolute', bottom: 0, left: 0, width: '100%', background: '#fff', borderTop: '1px solid #ddd' }}>
                <div style={{ padding: '10px 30px' }}>
                  <DynamicButton
                    onClick={handleSubmit}
                    label={"Submit"}
                    disabled={!region || !officeLocation}
                    color={background}
                    fullWidth
                  />
                </div>
              </div>
            </div>
          </Body>
          <CurveOverImage
            style={{
              position: "relative",
              zIndex: 1,
              marginTop: -10,
              width: "100%",
            }}
            fill={"white"}
          />
        </Children>
      </MainHolder>
    </>
  );
};

const Header = styled.div`
  /* width: 360px; */
  overflow: hidden;
  padding: 20px 20px 10px 20px;
  background-color: ${({ background }) => background};
  position: relative;
`;

export default BlackFridayPickup;
